<template>
    <div class="update-request" :class="{loading: loading}">
        <form @submit.prevent="updateRequest" accept-charset="UTF-8" novalidate="novalidate">
            <div class="row">
                <div class="col-md-7">
                    <div class="row">
                        <div class="form-group has-feedback col-sm-8 col-md-6" :class="{'has-error': errors.has('status')}">
                            <label for="request-status">Request Status</label>

                            <select name="request-status" id="request-status" v-model="compensationRequest.status" class="form-control">
                                <option v-bind:key="parseInt(status[0])" v-for="status in Object.entries(this.statusOptions).sort()" :value="parseInt(status[0])">{{ status[1] }}</option>
                            </select>

                            <span v-show="errors.has('status')" class="help-block">
                                {{ errors.first('status') }}
                            </span>
                        </div>

                        <div class="form-group has-feedback col-sm-8 col-md-6" :class="{'has-error': errors.has('type')}">
                            <label for="request-type">Request Type</label>

                            <select name="request-type" id="request-type" v-model="compensationRequest.type" class="form-control">
                                <option v-bind:key="parseInt(type[0])" v-for="type in Object.entries(this.typeOptions).sort()" :value="parseInt(type[0])">{{ type[1] }}</option>
                            </select>

                            <span v-show="errors.has('type')" class="help-block">
                                {{ errors.first('type') }}
                            </span>
                        </div>
                        
                        <div class="form-group has-feedback col-sm-8 col-md-6" :class="{'has-error': errors.has('request_amount')}">
                            <label for="request-amount" style="margin-left: 40px;">Requested Amount</label>

                            <div class="input-group" :class="{'has-error': errors.has('request_amount')}">
                                <span class="input-group-addon">$</span>

                                <input id="request-amount"
                                        class="form-control"
                                        min="0"
                                        name="request-amount"
                                        type="number"
                                        :disabled="true"
                                        v-model="compensationRequest.request_amount">
                            </div>

                            <span v-show="errors.has('request_amount')" class="help-block" style="margin-left: 40px;">
                                {{ errors.first('request_amount') }}
                            </span>
                        </div>

                        <div v-if="this.compensationRequest.status === this.STATUS_APPROVED" class="form-group has-feedback col-sm-8 col-md-6" :class="{'has-error': errors.has('approved_amount')}">
                            <label for="approved-amount" style="margin-left: 40px;">Approved Amount</label>

                            <div class="input-group" :class="{'has-error': errors.has('approved_amount')}">
                                <span class="input-group-addon">$</span>

                                <input id="approved-amount"
                                        class="form-control"
                                        min="0"
                                        name="approved-amount"
                                        type="number"
                                        v-model="compensationRequest.approved_amount"
                                        v-on:keydown.enter.prevent='this.updateRequest'>
                            </div>

                            <span v-show="errors.has('approved_amount')" class="help-block" style="margin-left: 40px;">
                                {{ errors.first('approved_amount') }}
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group has-feedback col-sm-8 col-md-6" :class="{'has-error': errors.has('provider_id')}">
                            <label for="request-provider-id">Provider</label>

                            <select name="request-provider-id" id="request-provider-id" v-model="compensationRequest.provider_id" class="form-control">
                                <option v-bind:key="provider[0]" v-for="provider in Object.entries(this.providerOptions).sort()" :value="provider[0]">{{ provider[1] }}</option>
                                <option value="Other">Other</option>
                            </select>

                            <span v-show="errors.has('provider_id')" class="help-block">
                                {{ errors.first('provider_id') }}
                            </span>
                        </div>

                        <div class="form-group has-feedback col-sm-12 col-md-6" v-if="this.compensationRequest.provider_id === 'Other' || this.compensationRequest.provider_id === null" :class="{'has-error': errors.has('provider_other')}">
                            <label for="request-provider-other">Provider Name</label>

                            <input id="request-provider-other"
                                    class="form-control"
                                    name="request-provider-other"
                                    type="text"
                                    v-model="compensationRequest.provider_other"
                                    v-on:keydown.enter.prevent='this.updateRequest'>

                            <span v-show="errors.has('provider_other')" class="help-block">
                                {{ errors.first('provider_other') }}
                            </span>
                        </div>
                    </div>

                    <div class="row" v-if="this.compensationRequest.type === this.TYPE_REIMBURSEMENT">
                        <div class="form-group has-feedback col-sm-12 col-md-12" :class="{'has-error': errors.has('reimbursement_address')}">
                            <label for="request-reimbursement-address">Full Mailing Address</label>

                            <input id="request-reimbursement-address"
                                    class="form-control"
                                    name="request-reimbursement-address"
                                    type="text"
                                    v-model="compensationRequest.reimbursement_address"
                                    v-on:keydown.enter.prevent='this.updateRequest'>

                            <span v-show="errors.has('reimbursement_address')" class="help-block">
                                {{ errors.first('reimbursement_address') }}
                            </span>
                        </div>
                    </div>

                    <div v-if="this.compensationRequest.status === this.STATUS_DENIED" class="row">
                        <div class="form-group has-feedback col-sm-8 col-md-12" :class="{'has-error': errors.has('denied_reason')}">
                            <label for="request-denied-reason">Denied Reason</label>

                            <select name="request-denied-reason" id="request-denied-reason" v-model="compensationRequest.denied_reason" class="form-control">
                                <option v-bind:key="parseInt(reason[0])" v-for="reason in Object.entries(this.deniedOptions).sort()" :value="parseInt(reason[0])">{{ reason[1] }}</option>
                            </select>

                            <span v-show="errors.has('denied_reason')" class="help-block">
                                {{ errors.first('denied_reason') }}
                            </span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group has-feedback col-sm-12 col-md-12" :class="{'has-error': errors.has('notes')}">
                            <label for="request-notes">Notes for Resident</label>

                            <textarea id="request-notes"
                                    class="form-control"
                                    style="max-width:55em; max-height: 10em;"
                                    name="request-notes"
                                    type="text"
                                    v-model="compensationRequest.notes"></textarea>

                            <span v-show="errors.has('notes')" class="help-block">
                                {{ errors.first('notes') }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="col-md-5">
                    <div class="row">
                        <div class="col-md-10">
                            <span><i>Message displayed to resident:</i></span>
                            <hr style="margin: 5px 0 15px 0;">
                            <p v-if="this.compensationRequest.status === this.STATUS_DENIED">
                                <span><b>Denied:</b></span>
                                {{ this.displayDeniedOptions[this.compensationRequest.denied_reason] }}
                            </p>
                            <p v-if="this.compensationRequest.status === this.STATUS_APPROVED">
                                <b>${{ (Math.round(this.compensationRequest.approved_amount * 100) / 100).toFixed(2) }} Approved</b>
                                <br>
                                <span v-if="this.compensationRequest.type === this.TYPE_PRICE_MATCH">
                                    Your price match request has been approved! <span v-if="this.compensationRequest.price_lock_date">Your account will be matched until {{ this.compensationRequest.price_lock_date }}</span>
                                </span>
                                <span v-else-if="this.compensationRequest.type === this.TYPE_REIMBURSEMENT">
                                    Your reimbursement request has been approved! Payment will be mailed to: <b>{{ this.compensationRequest.reimbursement_address }}</b>
                                </span>
                            </p>
                            <p v-else-if="this.compensationRequest.status === this.STATUS_PENDING">
                                Request submitted! Following review, you will receive an email confirmation at <i>{{ this.compensationRequest.user.email }}</i>.
                            </p>
                            <div v-if="this.compensationRequest.type === this.TYPE_REIMBURSEMENT && this.compensationRequest.status !== this.STATUS_DENIED">
                                <span>Reimbursement payment is issued 15-45 days following the launch of the new bulk program.</span>
                            </div>
                            <br v-if="this.compensationRequest.type === this.TYPE_REIMBURSEMENT && this.compensationRequest.status !== this.STATUS_DENIED">
                            {{ this.compensationRequest.notes }}
                        </div>
                    </div>
                </div>
            </div>

            <hr>

            <div class="row">
                <div class="col-xs-7">
                    <button type="button" class="btn btn-sm btn-default" @click="resetRequest" :class="{ 'faded': this.faded }">
                        Discard Changes
                    </button>
                </div>

                <div class="col-xs-5 text-right">
                    <button type="submit" class="btn btn-sm btn-block btn-success" :disabled="loading">
                        Update Request
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    /**
     * Note: Cannot be nested within a form element with a non-https action
     */
    export default {
        props: {
            afterSave: {
                default: () => {
                    return function(){
                    };
                }
            },

            statusOptions: {
                type: Object,
                required: true
            },

            deniedOptions: {
                type: Object,
                required: true
            },

            displayDeniedOptions: {
                type: Object,
                required: true
            },

            typeOptions: {
                type: Object,
                required: true
            },

            providerOptions: {
                type: Object,
                required: true
            },

            request: {
                type: Object,
                required: true
            },

            appUrl: {
                type: String,
                required: true,
            },

            accountCharge: {
                type: Number,
                required: true
            }
        },

        getModelData() {
                return {
                    
                };
            },

        created() {
            this.init();
        },

        data() {
            return {
                TYPE_PRICE_MATCH: 0,
                TYPE_REIMBURSEMENT: 1,

                STATUS_DENIED: 0,
                STATUS_APPROVED: 1,
                STATUS_PENDING: 2,
                
                DENIED_OTHER: 0,
                DENIED_INVALID_DOCUMENT: 1,
                DENIED_INVALID_ADDRESS: 2,
                DENIED_ADDENDUM_IN_LEASE: 3,

                loading: false,

                style: {
                    base: {
                        color: '#282828',
                        fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#282828'
                        },
                        lineHeight: '26px',
                        padding: '8px'
                    },

                    invalid: {
                        color: '#C70039',
                        iconColor: '#900C3F'
                    },
                },

                compensationRequest: {
                    type: null,
                    request_amount: null,
                    approved_amount: null,
                    provider_id: null,
                    provider_other: null,
                    reimbursement_address: null,
                }
            };
        },

        computed: {
            faded() {
                return JSON.stringify(this.request) === JSON.stringify(this.compensationRequest)
            }
        },

        methods: {
            init(){
                this.compensationRequest = JSON.parse(JSON.stringify(this.request))
            },

            resetRequest() {
                this.compensationRequest = JSON.parse(JSON.stringify(this.request))
                this.errors.clear();
            },

            nullOrEmpty(item) {
                switch (typeof(item)) {
                    case 'string':
                        return item === null || item === '' || item === undefined;
                    case 'number':
                        return item === null || item === undefined || isNaN(item);
                    default:
                        return item === null || item === undefined;
                }
            },

            validate() {
                // Check that always required fields are not null
                if (this.nullOrEmpty(this.compensationRequest.status)) {
                    this.errors.add({ field: 'status', msg: 'Must enter request status' });
                }
                if (this.nullOrEmpty(this.compensationRequest.type)) {
                    this.errors.add({ field: 'type', msg: 'Must enter request type' });
                }
                // Check conditional required fields
                if (this.compensationRequest.status === this.STATUS_APPROVED && ['', null].includes(this.compensationRequest.approved_amount)) {
                    this.errors.add({ field: 'approved_amount', msg: 'Must enter approved amount to approve request' });
                } else if (this.compensationRequest.status === this.STATUS_DENIED && this.nullOrEmpty(this.compensationRequest.denied_reason)) {
                    this.errors.add({ field: 'denied_reason', msg: 'Must select a reason for denied request' });
                }
                if (this.compensationRequest.type === this.TYPE_REIMBURSEMENT && this.compensationRequest.status === this.STATUS_APPROVED && this.nullOrEmpty(this.compensationRequest.reimbursement_address)) {
                    this.errors.add({ field: 'reimbursement_address', msg: 'Must enter a valid address for reimbursement check' });
                }
                if (this.compensationRequest.type === this.TYPE_PRICE_MATCH && this.compensationRequest.denied_reason === this.DENIED_INVALID_ADDRESS) {
                    this.errors.add({ field: 'denied_reason', msg: 'Cannot deny price match for invalid mailing address' });
                }
                if (this.compensationRequest.type === this.TYPE_REIMBURSEMENT && this.compensationRequest.denied_reason === this.DENIED_ADDENDUM_IN_LEASE) {
                    this.errors.add({ field: 'denied_reason', msg: 'Cannot deny reimbursement for the addendum already being in the lease' });
                }
                if (
                    this.compensationRequest.status === this.STATUS_DENIED &&
                    (this.compensationRequest.denied_reason === this.DENIED_OTHER || this.compensationRequest.denied_reason === this.DENIED_INVALID_DOCUMENT) &&
                    (this.nullOrEmpty(this.compensationRequest.notes))
                ) {
                    this.errors.add({ field: 'notes', msg: 'Must enter notes with ' + this.deniedOptions[this.compensationRequest.denied_reason] + ' as denied reason' });
                }
                if ((this.compensationRequest.provider_id === 'Other' || this.compensationRequest.provider_id  === null) && this.nullOrEmpty(this.compensationRequest.provider_other)) {
                    this.errors.add({ field: 'provider_other', msg: 'Must enter a provider name' });
                } else if (this.compensationRequest.provider_id === '') {
                    this.errors.add({ field: 'provider_id', msg: 'Must select a provider' });
                }
                if (this.compensationRequest.status === this.STATUS_APPROVED && this.compensationRequest.type === this.TYPE_PRICE_MATCH && this.accountCharge !== parseFloat(this.compensationRequest.approved_amount)) {
                    this.errors.add({ field: 'approved_amount', msg: 'Account charge must match approved amount to approve request' });
                }

                return this.errors.items.length === 0
            },

            updateRequest() {
                this.loading = true;
                this.errors.clear();
                var url = this.appUrl + '/compensationRequests/' + this.compensationRequest.id;

                if (!this.validate()) {
                    this.loading = false;
                    return
                }

                return axios.put(url, {
                    'CompensationRequest': {
                        'status': this.compensationRequest.status,
                        'type': this.compensationRequest.type,
                        'approved_amount': parseFloat(this.compensationRequest.approved_amount),
                        'provider_id': [null, '', 'Other'].includes(this.compensationRequest.provider_id) ? null : this.compensationRequest.provider_id,
                        'provider_other': [null, '', 'Other'].includes(this.compensationRequest.provider_id) ? this.compensationRequest.provider_other : null,
                        'notes': this.compensationRequest.notes,
                        'denied_reason': this.compensationRequest.status === this.STATUS_DENIED ? this.compensationRequest.denied_reason : null,
                        'reimbursement_address': this.compensationRequest.type === this.TYPE_REIMBURSEMENT ? this.compensationRequest.reimbursement_address : null,
                        'id': this.compensationRequest.id
                    }
                })
                    .then((response) => {
                        if ( response.data.errors ) {
                            for (const [key, value] of Object.entries(response.data.errors)) {
                                this.errors.add({
                                    field: key,
                                    msg: value[0]
                                });
                            }
                        } else if ( response.data.error ) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: response.data.error,
                            } );
                        } else {
                            window.location.reload();
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    })
                    .catch( this.$root.handleErrors );
            }
        }
    }
</script>
